import Strings from "src/shared/Strings";
import { isBuiltCampaignComponentSocket } from "../../setting/model/BuiltCampaignComponentSocket";
export class RoleV3ComponentAdapter {
    constructor(component) {
        this.component = component;
    }
    getComponentId() {
        return this.component.id;
    }
    getCampaignId() {
        return this.component.campaign_id;
    }
    getDisplayName() {
        return Strings.capitalize(this.component.name);
    }
    getName() {
        return this.component.name;
    }
    getJourneyV3ComponentIds() {
        const journeySocket = this.component.findSetting("journey");
        if (!journeySocket || !isBuiltCampaignComponentSocket(journeySocket)) {
            return [];
        }
        return journeySocket.getInstalledComponentIds();
    }
    getRewardComponentIds() {
        const rewardSocket = this.component.findSetting("rewards");
        if (!rewardSocket || !isBuiltCampaignComponentSocket(rewardSocket)) {
            return [];
        }
        return rewardSocket.getInstalledComponentIds();
    }
    getRewardSocketName() {
        return "rewards";
    }
    isRewardable() {
        const rewardSocketName = this.getRewardSocketName();
        return (rewardSocketName !== null &&
            this.component.findSetting(rewardSocketName) !== undefined);
    }
    getSequence() {
        const variable = this.component.findVariable("sequence");
        const defaultValue = variable === null || variable === void 0 ? void 0 : variable.getValue("default");
        if (defaultValue) {
            return defaultValue;
        }
        return "100";
    }
    getColor() {
        return this.component.getColor();
    }
}
